import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { paths } from '../../../../routing/path';

export interface PracticeMenuItemProps {
    practice: any;
}

export const PracticeMenuItem = (props: PracticeMenuItemProps) => {
    const { practice } = props;

    return (
        <div className="flex-container">
            <LeftMenuItem
                icon="pe-7s-share"
                label={practice.name}
                to={paths.venues.grow.practiceById(practice.id)}
                flagCode={`${NotificationFlagsCategories.PracticesCode}.${practice.id}`}
                className={
                    practice.id
                        ? 'vertical-nav-menu'
                        : 'vertical-nav-menu custom'
                }
                marginLeft={-15}
                trackingAction={practice.name}
                forceReload
            />
        </div>
    );
};
